var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('span',{class:{
                        subheading: true,
                        'font-weight-medium': true,
                        'primary--text': _vm.isSelf
                    }},[_vm._v(" "+_vm._s(_vm.user.displayName)+" ")])]),_c('v-flex',[_c('span',{staticClass:"pre"},[_vm._v(_vm._s(_vm.value.message))])])],1)],1),_c('v-card-actions',[_c('v-spacer'),_c('span',[_vm._v(_vm._s(`${_vm.value.date} ${_vm.value.time}`))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }